import { MetadataStore } from 'breeze-client';

import { Account } from './account';
import { AccountBalance } from './account-balance';
import { AccountClass } from './account-class';
import { AccountDatum } from './account-datum';
import { AccountGroup } from './account-group';
import { AccountTemplate } from './account-template';
import { AccountTransfer } from './account-transfer';
import { AccountValue } from './account-value';
import { Action } from './action';
import { Address } from './address';
import { AddressMerged } from './address-merged';
import { AddressType } from './address-type';
import { Admin } from './admin';
import { AdminAddress } from './admin-address';
import { AdminAppointmentMethod } from './admin-appointment-method';
import { AdminBankrupt } from './admin-bankrupt';
import { AdminContact } from './admin-contact';
import { AdminContactRole } from './admin-contact-role';
import { AdminCustomProperty } from './admin-custom-property';
import { AdminDatum } from './admin-datum';
import { AdminNumber } from './admin-number';
import { AdminRole } from './admin-role';
import { AdminSetting } from './admin-setting';
import { AdminStatus } from './admin-status';
import { AdminSubType } from './admin-sub-type';
import { AdminType } from './admin-type';
import { AdminTypeHistory } from './admin-type-history';
import { AdminWorkTeam } from './admin-work-team';
import { ApplicationSetting } from './application-setting';
import { AppointeeAppointment } from './appointee-appointment';
import { Appointment } from './appointment';
import { AppointmentMethod } from './appointment-method';
import { AppointmentType } from './appointment-type';
import { Asset } from './asset';
import { AssetClass } from './asset-class';
import { Bank } from './bank';
import { Bankrupt } from './bankrupt';
import { BankruptAddress } from './bankrupt-address';
import { BankruptNumber } from './bankrupt-number';
import { BankruptcyPaymentClass } from './bankruptcy-payment-class';
import { Batch } from './batch';
import { Bond } from './bond';
import { Bonding } from './bonding';
import { Contact } from './contact';
import { ContactAddress } from './contact-address';
import { ContactMailingList } from './contact-mailing-list';
import { ContactNumber } from './contact-number';
import { Contribution } from './contribution';
import { Counterparty } from './counterparty';
import { CounterpartyAddress } from './counterparty-address';
import { CounterpartyCounterpartyType } from './counterparty-counterparty-type';
import { CounterpartyDataMerged } from './counterparty-data-merged';
import { CounterpartyDatum } from './counterparty-datum';
import { CounterpartyMaster } from './counterparty-master';
import { CounterpartyMerged } from './counterparty-merged';
import { CounterpartyMergedAddress } from './counterparty-merged-address';
import { CounterpartyMergedCounterparty } from './counterparty-merged-counterparty';
import { CounterpartyMergedNumber } from './counterparty-merged-number';
import { CounterpartyNumber } from './counterparty-number';
import { CounterpartyType } from './counterparty-type';
import { Creditor } from './creditor';
import { CreditorClaim } from './creditor-claim';
import { CreditorClaimType } from './creditor-claim-type';
import { CreditorClass } from './creditor-class';
import { CreditorContact } from './creditor-contact';
import { CreditorDatum } from './creditor-datum';
import { CreditorDividend } from './creditor-dividend';
import { CurrencyRate } from './currency-rate';
import { CurrencyType } from './currency-type';
import { CustomProperty } from './custom-property';
import { CustomPropertyAdminType } from './custom-property-admin-type';
import { CustomPropertyType } from './custom-property-type';
import { DataCache } from './data-cache';
import { Dividend } from './dividend';
import { Document } from './document';
import { DocumentDatum } from './document-datum';
import { DocumentRecipient } from './document-recipient';
import { DocumentRecipientAction } from './document-recipient-action';
import { DocumentRequest } from './document-request';
import { DocumentSetting } from './document-setting';
import { Employee } from './employee';
import { EmployeeClaim } from './employee-claim';
import { EmployeeDatum } from './employee-datum';
import { EmployeeNumber } from './employee-number';
import { Entry } from './entry';
import { EntryDatum } from './entry-datum';
import { EntryDeleted } from './entry-deleted';
import { EntryEftdatum } from './entry-eftdatum';
import { Holiday } from './holiday';
import { Image } from './image';
import { IndustryType } from './industry-type';
import { Insurer } from './insurer';
import { Liability } from './liability';
import { Location } from './location';
import { Lodgement } from './lodgement';
import { Lookup } from './lookup';
import { LookupList } from './lookup-list';
import { MailingList } from './mailing-list';
import { Meeting } from './meeting';
import { MeetingAttendance } from './meeting-attendance';
import { MeetingAttendanceResolution } from './meeting-attendance-resolution';
import { MeetingResolution } from './meeting-resolution';
import { MeetingType } from './meeting-type';
import { MergeSetting } from './merge-setting';
import { MergeTemplate } from './merge-template';
import { MergeTemplateCategory } from './merge-template-category';
import { MergeTemplateGroup } from './merge-template-group';
import { MergeTemplateReplaceField } from './merge-template-replace-field';
import { Number } from './number';
import { NumberMerged } from './number-merged';
import { NumberType } from './number-type';
import { Period } from './period';
import { Practice } from './practice';
import { PracticeAddress } from './practice-address';
import { PracticeBank } from './practice-bank';
import { PracticeNumber } from './practice-number';
import { ProxyType } from './proxy-type';
import { Rate } from './rate';
import { RateType } from './rate-type';
import { RateValue } from './rate-value';
import { Reconciliation } from './reconciliation';
import { Relationship } from './relationship';
import { ReplaceField } from './replace-field';
import { Report } from './report';
import { ReportCategory } from './report-category';
import { ReportLayout } from './report-layout';
import { ReportReportCategory } from './report-report-category';
import { Resource } from './resource';
import { Role } from './role';
import { Script } from './script';
import { SearchOrder } from './search-order';
import { Security } from './security';
import { SecurityAsset } from './security-asset';
import { SecurityMatrix } from './security-matrix';
import { SecurityRoleAuditHeader } from './security-role-audit-header';
import { SecurityType } from './security-type';
import { ShareHolderNumber } from './share-holder-number';
import { Shareholder } from './shareholder';
import { ShareholderClass } from './shareholder-class';
import { ShareholderDividend } from './shareholder-dividend';
import { Shareholding } from './shareholding';
import { Shortcut } from './shortcut';
import { StaticDatum } from './static-datum';
import { SubEntry } from './sub-entry';
import { SuperFund } from './super-fund';
import { TaskAudit } from './task-audit';
import { TaskGroup } from './task-group';
import { TaxCode } from './tax-code';
import { TaxGroup } from './tax-group';
import { Template } from './template';
import { TemplateAdminType } from './template-admin-type';
import { Term } from './term';
import { Transfer } from './transfer';
import { TransferLiability } from './transfer-liability';
import { TransferWebAdmin } from './transfer-web-admin';
import { TransferWebRequest } from './transfer-web-request';
import { TransferWebRequestWatch } from './transfer-web-request-watch';
import { TransferWebResponse } from './transfer-web-response';
import { TxnBatch } from './txn-batch';
import { TxnDetail } from './txn-detail';
import { TxnHeader } from './txn-header';
import { User } from './user';
import { UserAdminRole } from './user-admin-role';
import { UserManager } from './user-manager';
import { UserNumber } from './user-number';
import { UserRole } from './user-role';
import { UserSetting } from './user-setting';
import { UserSettingAdmin } from './user-setting-admin';
import { UserStringSetting } from './user-string-setting';
import { UserType } from './user-type';
import { iTask } from './i-task';

export class InsolRegistrationHelper {

    static register(metadataStore: MetadataStore) {
        metadataStore.registerEntityTypeCtor('Account', Account);
        metadataStore.registerEntityTypeCtor('AccountBalance', AccountBalance);
        metadataStore.registerEntityTypeCtor('AccountClass', AccountClass);
        metadataStore.registerEntityTypeCtor('AccountDatum', AccountDatum);
        metadataStore.registerEntityTypeCtor('AccountGroup', AccountGroup);
        metadataStore.registerEntityTypeCtor('AccountTemplate', AccountTemplate);
        metadataStore.registerEntityTypeCtor('AccountTransfer', AccountTransfer);
        metadataStore.registerEntityTypeCtor('AccountValue', AccountValue);
        metadataStore.registerEntityTypeCtor('Action', Action);
        metadataStore.registerEntityTypeCtor('Address', Address);
        metadataStore.registerEntityTypeCtor('AddressMerged', AddressMerged);
        metadataStore.registerEntityTypeCtor('AddressType', AddressType);
        metadataStore.registerEntityTypeCtor('Admin', Admin);
        metadataStore.registerEntityTypeCtor('AdminAddress', AdminAddress);
        metadataStore.registerEntityTypeCtor('AdminAppointmentMethod', AdminAppointmentMethod);
        metadataStore.registerEntityTypeCtor('AdminBankrupt', AdminBankrupt);
        metadataStore.registerEntityTypeCtor('AdminContact', AdminContact);
        metadataStore.registerEntityTypeCtor('AdminContactRole', AdminContactRole);
        metadataStore.registerEntityTypeCtor('AdminCustomProperty', AdminCustomProperty);
        metadataStore.registerEntityTypeCtor('AdminDatum', AdminDatum);
        metadataStore.registerEntityTypeCtor('AdminNumber', AdminNumber);
        metadataStore.registerEntityTypeCtor('AdminRole', AdminRole);
        metadataStore.registerEntityTypeCtor('AdminSetting', AdminSetting);
        metadataStore.registerEntityTypeCtor('AdminStatus', AdminStatus);
        metadataStore.registerEntityTypeCtor('AdminSubType', AdminSubType);
        metadataStore.registerEntityTypeCtor('AdminType', AdminType);
        metadataStore.registerEntityTypeCtor('AdminTypeHistory', AdminTypeHistory);
        metadataStore.registerEntityTypeCtor('AdminWorkTeam', AdminWorkTeam);
        metadataStore.registerEntityTypeCtor('ApplicationSetting', ApplicationSetting);
        metadataStore.registerEntityTypeCtor('AppointeeAppointment', AppointeeAppointment);
        metadataStore.registerEntityTypeCtor('Appointment', Appointment);
        metadataStore.registerEntityTypeCtor('AppointmentMethod', AppointmentMethod);
        metadataStore.registerEntityTypeCtor('AppointmentType', AppointmentType);
        metadataStore.registerEntityTypeCtor('Asset', Asset);
        metadataStore.registerEntityTypeCtor('AssetClass', AssetClass);
        metadataStore.registerEntityTypeCtor('Bank', Bank);
        metadataStore.registerEntityTypeCtor('Bankrupt', Bankrupt);
        metadataStore.registerEntityTypeCtor('BankruptAddress', BankruptAddress);
        metadataStore.registerEntityTypeCtor('BankruptNumber', BankruptNumber);
        metadataStore.registerEntityTypeCtor('BankruptcyPaymentClass', BankruptcyPaymentClass);
        metadataStore.registerEntityTypeCtor('Batch', Batch);
        metadataStore.registerEntityTypeCtor('Bond', Bond);
        metadataStore.registerEntityTypeCtor('Bonding', Bonding);
        metadataStore.registerEntityTypeCtor('Contact', Contact);
        metadataStore.registerEntityTypeCtor('ContactAddress', ContactAddress);
        metadataStore.registerEntityTypeCtor('ContactMailingList', ContactMailingList);
        metadataStore.registerEntityTypeCtor('ContactNumber', ContactNumber);
        metadataStore.registerEntityTypeCtor('Contribution', Contribution);
        metadataStore.registerEntityTypeCtor('Counterparty', Counterparty);
        metadataStore.registerEntityTypeCtor('CounterpartyAddress', CounterpartyAddress);
        metadataStore.registerEntityTypeCtor('CounterpartyCounterpartyType', CounterpartyCounterpartyType);
        metadataStore.registerEntityTypeCtor('CounterpartyDataMerged', CounterpartyDataMerged);
        metadataStore.registerEntityTypeCtor('CounterpartyDatum', CounterpartyDatum);
        metadataStore.registerEntityTypeCtor('CounterpartyMaster', CounterpartyMaster);
        metadataStore.registerEntityTypeCtor('CounterpartyMerged', CounterpartyMerged);
        metadataStore.registerEntityTypeCtor('CounterpartyMergedAddress', CounterpartyMergedAddress);
        metadataStore.registerEntityTypeCtor('CounterpartyMergedCounterparty', CounterpartyMergedCounterparty);
        metadataStore.registerEntityTypeCtor('CounterpartyMergedNumber', CounterpartyMergedNumber);
        metadataStore.registerEntityTypeCtor('CounterpartyNumber', CounterpartyNumber);
        metadataStore.registerEntityTypeCtor('CounterpartyType', CounterpartyType);
        metadataStore.registerEntityTypeCtor('Creditor', Creditor);
        metadataStore.registerEntityTypeCtor('CreditorClaim', CreditorClaim);
        metadataStore.registerEntityTypeCtor('CreditorClaimType', CreditorClaimType);
        metadataStore.registerEntityTypeCtor('CreditorClass', CreditorClass);
        metadataStore.registerEntityTypeCtor('CreditorContact', CreditorContact);
        metadataStore.registerEntityTypeCtor('CreditorDatum', CreditorDatum);
        metadataStore.registerEntityTypeCtor('CreditorDividend', CreditorDividend);
        metadataStore.registerEntityTypeCtor('CurrencyRate', CurrencyRate);
        metadataStore.registerEntityTypeCtor('CurrencyType', CurrencyType);
        metadataStore.registerEntityTypeCtor('CustomProperty', CustomProperty);
        metadataStore.registerEntityTypeCtor('CustomPropertyAdminType', CustomPropertyAdminType);
        metadataStore.registerEntityTypeCtor('CustomPropertyType', CustomPropertyType);
        metadataStore.registerEntityTypeCtor('DataCache', DataCache);
        metadataStore.registerEntityTypeCtor('Dividend', Dividend);
        metadataStore.registerEntityTypeCtor('Document', Document);
        metadataStore.registerEntityTypeCtor('DocumentDatum', DocumentDatum);
        metadataStore.registerEntityTypeCtor('DocumentRecipient', DocumentRecipient);
        metadataStore.registerEntityTypeCtor('DocumentRecipientAction', DocumentRecipientAction);
        metadataStore.registerEntityTypeCtor('DocumentRequest', DocumentRequest);
        metadataStore.registerEntityTypeCtor('DocumentSetting', DocumentSetting);
        metadataStore.registerEntityTypeCtor('Employee', Employee);
        metadataStore.registerEntityTypeCtor('EmployeeClaim', EmployeeClaim);
        metadataStore.registerEntityTypeCtor('EmployeeDatum', EmployeeDatum);
        metadataStore.registerEntityTypeCtor('EmployeeNumber', EmployeeNumber);
        metadataStore.registerEntityTypeCtor('Entry', Entry);
        metadataStore.registerEntityTypeCtor('EntryDatum', EntryDatum);
        metadataStore.registerEntityTypeCtor('EntryDeleted', EntryDeleted);
        metadataStore.registerEntityTypeCtor('EntryEftdatum', EntryEftdatum);
        metadataStore.registerEntityTypeCtor('Holiday', Holiday);
        metadataStore.registerEntityTypeCtor('Image', Image);
        metadataStore.registerEntityTypeCtor('IndustryType', IndustryType);
        metadataStore.registerEntityTypeCtor('Insurer', Insurer);
        metadataStore.registerEntityTypeCtor('Liability', Liability);
        metadataStore.registerEntityTypeCtor('Location', Location);
        metadataStore.registerEntityTypeCtor('Lodgement', Lodgement);
        metadataStore.registerEntityTypeCtor('Lookup', Lookup);
        metadataStore.registerEntityTypeCtor('LookupList', LookupList);
        metadataStore.registerEntityTypeCtor('MailingList', MailingList);
        metadataStore.registerEntityTypeCtor('Meeting', Meeting);
        metadataStore.registerEntityTypeCtor('MeetingAttendance', MeetingAttendance);
        metadataStore.registerEntityTypeCtor('MeetingAttendanceResolution', MeetingAttendanceResolution);
        metadataStore.registerEntityTypeCtor('MeetingResolution', MeetingResolution);
        metadataStore.registerEntityTypeCtor('MeetingType', MeetingType);
        metadataStore.registerEntityTypeCtor('MergeSetting', MergeSetting);
        metadataStore.registerEntityTypeCtor('MergeTemplate', MergeTemplate);
        metadataStore.registerEntityTypeCtor('MergeTemplateCategory', MergeTemplateCategory);
        metadataStore.registerEntityTypeCtor('MergeTemplateGroup', MergeTemplateGroup);
        metadataStore.registerEntityTypeCtor('MergeTemplateReplaceField', MergeTemplateReplaceField);
        metadataStore.registerEntityTypeCtor('Number', Number);
        metadataStore.registerEntityTypeCtor('NumberMerged', NumberMerged);
        metadataStore.registerEntityTypeCtor('NumberType', NumberType);
        metadataStore.registerEntityTypeCtor('Period', Period);
        metadataStore.registerEntityTypeCtor('Practice', Practice);
        metadataStore.registerEntityTypeCtor('PracticeAddress', PracticeAddress);
        metadataStore.registerEntityTypeCtor('PracticeBank', PracticeBank);
        metadataStore.registerEntityTypeCtor('PracticeNumber', PracticeNumber);
        metadataStore.registerEntityTypeCtor('ProxyType', ProxyType);
        metadataStore.registerEntityTypeCtor('Rate', Rate);
        metadataStore.registerEntityTypeCtor('RateType', RateType);
        metadataStore.registerEntityTypeCtor('RateValue', RateValue);
        metadataStore.registerEntityTypeCtor('Reconciliation', Reconciliation);
        metadataStore.registerEntityTypeCtor('Relationship', Relationship);
        metadataStore.registerEntityTypeCtor('ReplaceField', ReplaceField);
        metadataStore.registerEntityTypeCtor('Report', Report);
        metadataStore.registerEntityTypeCtor('ReportCategory', ReportCategory);
        metadataStore.registerEntityTypeCtor('ReportLayout', ReportLayout);
        metadataStore.registerEntityTypeCtor('ReportReportCategory', ReportReportCategory);
        metadataStore.registerEntityTypeCtor('Resource', Resource);
        metadataStore.registerEntityTypeCtor('Role', Role);
        metadataStore.registerEntityTypeCtor('Script', Script);
        metadataStore.registerEntityTypeCtor('SearchOrder', SearchOrder);
        metadataStore.registerEntityTypeCtor('Security', Security);
        metadataStore.registerEntityTypeCtor('SecurityAsset', SecurityAsset);
        metadataStore.registerEntityTypeCtor('SecurityMatrix', SecurityMatrix);
        metadataStore.registerEntityTypeCtor('SecurityRoleAuditHeader', SecurityRoleAuditHeader);
        metadataStore.registerEntityTypeCtor('SecurityType', SecurityType);
        metadataStore.registerEntityTypeCtor('ShareHolderNumber', ShareHolderNumber);
        metadataStore.registerEntityTypeCtor('Shareholder', Shareholder);
        metadataStore.registerEntityTypeCtor('ShareholderClass', ShareholderClass);
        metadataStore.registerEntityTypeCtor('ShareholderDividend', ShareholderDividend);
        metadataStore.registerEntityTypeCtor('Shareholding', Shareholding);
        metadataStore.registerEntityTypeCtor('Shortcut', Shortcut);
        metadataStore.registerEntityTypeCtor('StaticDatum', StaticDatum);
        metadataStore.registerEntityTypeCtor('SubEntry', SubEntry);
        metadataStore.registerEntityTypeCtor('SuperFund', SuperFund);
        metadataStore.registerEntityTypeCtor('TaskAudit', TaskAudit);
        metadataStore.registerEntityTypeCtor('TaskGroup', TaskGroup);
        metadataStore.registerEntityTypeCtor('TaxCode', TaxCode);
        metadataStore.registerEntityTypeCtor('TaxGroup', TaxGroup);
        metadataStore.registerEntityTypeCtor('Template', Template);
        metadataStore.registerEntityTypeCtor('TemplateAdminType', TemplateAdminType);
        metadataStore.registerEntityTypeCtor('Term', Term);
        metadataStore.registerEntityTypeCtor('Transfer', Transfer);
        metadataStore.registerEntityTypeCtor('TransferLiability', TransferLiability);
        metadataStore.registerEntityTypeCtor('TransferWebAdmin', TransferWebAdmin);
        metadataStore.registerEntityTypeCtor('TransferWebRequest', TransferWebRequest);
        metadataStore.registerEntityTypeCtor('TransferWebRequestWatch', TransferWebRequestWatch);
        metadataStore.registerEntityTypeCtor('TransferWebResponse', TransferWebResponse);
        metadataStore.registerEntityTypeCtor('TxnBatch', TxnBatch);
        metadataStore.registerEntityTypeCtor('TxnDetail', TxnDetail);
        metadataStore.registerEntityTypeCtor('TxnHeader', TxnHeader);
        metadataStore.registerEntityTypeCtor('User', User);
        metadataStore.registerEntityTypeCtor('UserAdminRole', UserAdminRole);
        metadataStore.registerEntityTypeCtor('UserManager', UserManager);
        metadataStore.registerEntityTypeCtor('UserNumber', UserNumber);
        metadataStore.registerEntityTypeCtor('UserRole', UserRole);
        metadataStore.registerEntityTypeCtor('UserSetting', UserSetting);
        metadataStore.registerEntityTypeCtor('UserSettingAdmin', UserSettingAdmin);
        metadataStore.registerEntityTypeCtor('UserStringSetting', UserStringSetting);
        metadataStore.registerEntityTypeCtor('UserType', UserType);
        metadataStore.registerEntityTypeCtor('iTask', iTask);
    }
}
